export default __webpack_public_path__ + "static/media/includeImg3.9d5d93c7.jpg";